import Api from "../../../lib/api";
import ProfTestChatForm from "./prof-test-chat-form";
import scrollLock from 'scroll-lock';

export default class ProfTestChat {
    constructor(id) {
        this.id = id;
        this.$root = null;

        this.$greetingTextBlock = null;
        this.$chatStartBlock = null;
        this.$chatStartBtn = null;
        this.$chatStartHolderBtn = null;
        this.$chatToogleBtn = null;

        this.$chatListBlock = null;
        this.$chatResultBlock = null;

        this.$chatListForm = null;
        this.$chatPostForm = null;
        this.$chatResult = null;

        this.chatId = null;
        this.pageMode = null;

        this.$chatTypingTemplate = null;
        this.$chatPostFormTemplate = null;
        this.$chatProgressTemplate = null;

        this.activeIndex = 0;

        this.isOpen = false;
        this.isStarted = false;

        this.init();
    }

    init() {
        this.getElements();
        this.getFields();

        if (this.$root) {
            this.initMode();
            this.addStartChatHandler();
            this.addWidgetOpenHandler();
            this.addWindowHandler();
            this.addToggleBtnHandler();
        }
    }

    getElements() {
        this.$root = document.getElementById(this.id);

        if (this.$root) {
            this.$greetingTextBlock = this.$root.querySelector('#prof-test-chat-greeting-text');

            this.$chatStartBlock = this.$root.querySelector('#prof-test-chat-start-block');
            this.$chatStartBtn = this.$root.querySelector('#prof-test-chat-start-btn');

            this.$chatStartHolderBtn = document.querySelector('#prof-test-chat-holder-start-btn');
            this.$chatToogleBtn = this.$root.querySelector('#prof-test-chat-header-toggle-btn');

            this.$chatListBlock = this.$root.querySelector('#prof-test-chat-list');
            this.$chatResultBlock = this.$root.querySelector('#prof-test-chat-result');

            this.$chatTypingTemplate = this.$root.querySelector('#prof-test-chat-typing');
            this.$chatPostFormTemplate = this.$root.querySelector('#prof-test-chat-post-form');
            this.$chatProgressTemplate = this.$root.querySelector('#prof-test-chat-header-progress');
        }
    }

    getFields() {
        if (this.$root) {
            this.chatId = this.$root.getAttribute('data-entry-id');
            this.pageMode = this.$root.getAttribute('data-mode');
        }
    }

    initMode() {
        const wWidth = window.innerWidth;
        const wHeight = window.innerHeight;
        const maxHeight = window.innerHeight - (44 + 60);

        if (this.pageMode === 'page') {
            if (wWidth < 905) {
                this.$root.style.position = 'fixed';
                this.$root.style.left = '10px';
                this.$root.style.width = (wWidth - 20) + 'px';
                this.$root.style.maxHeight = 'unset';

                if (this.isOpen) {
                    scrollLock.disablePageScroll([document.body]);

                    this.$root.style.height =  (wHeight - 20) + 'px';
                    this.$root.style.padding = '10px';
                    this.$root.style.borderWidth = '1px';
                    this.$root.style.bottom = '10px';
                    this.$root.style.zIndex = 2147483647;
                } else {
                    scrollLock.clearQueueScrollLocks();
                    scrollLock.enablePageScroll(document.body);

                    this.$root.style.height = '0px';
                    this.$root.style.padding = '0px';
                    this.$root.style.borderWidth = '0px';
                    this.$root.style.bottom = '0px';
                    this.$root.style.zIndex = 'unset';
                }
            } else {
                scrollLock.clearQueueScrollLocks();
                scrollLock.enablePageScroll(document.body);

                this.$root.style.position = 'static';
                this.$root.style.bottom = 'unset';
                this.$root.style.left = 'unset';
                this.$root.style.width = 'auto';
                this.$root.style.height = 'auto';
                this.$root.style.padding = '10px';
                this.$root.style.borderWidth = '1px';
                this.$root.style.zIndex = 'unset';

                if (maxHeight < 455) {
                    this.$root.style.maxHeight = 455 + 'px';
                } else if (maxHeight > 700) {
                    this.$root.style.maxHeight = 700 + 'px';
                } else {
                    this.$root.style.maxHeight = maxHeight + 'px';
                }
            }
        } else if (this.pageMode === 'course') {
            const $widgetBlock = document.querySelector('.course_proftest');

            if (wWidth < 905) {
                this.$root.style.position = 'fixed';
                this.$root.style.left = '10px';
                this.$root.style.width = (wWidth - 20) + 'px';
                this.$root.style.maxHeight = 'unset';
                this.$root.style.height =  (wHeight - 20) + 'px';
                this.$root.style.bottom = ((wHeight + 20) * -1) + 'px';
                this.$root.style.zIndex = 2147483647;

                $widgetBlock.style.zIndex = 16776999;

                if (this.isOpen) {
                    scrollLock.disablePageScroll([document.body]);
                    $widgetBlock.style.zIndex = 2147483647;

                    this.$root.style.bottom = '10px';
                } else {
                    scrollLock.clearQueueScrollLocks();
                    scrollLock.enablePageScroll(document.body);

                    this.$root.style.bottom = ((wHeight + 20) * -1) + 'px';
                    $widgetBlock.style.zIndex = 16776999;
                }
            } else {
                scrollLock.clearQueueScrollLocks();
                scrollLock.enablePageScroll(document.body);

                this.$root.style.position = 'absolute';
                this.$root.style.left = '0px';
                this.$root.style.width = 'auto';
                this.$root.style.height = 'auto';
                this.$root.style.zIndex = 2147483647;

                $widgetBlock.style.zIndex = 16776999;

                if (maxHeight < 455) {
                    this.$root.style.maxHeight = 455 + 'px';
                } else if (maxHeight > 700) {
                    this.$root.style.maxHeight = 700 + 'px';
                } else {
                    this.$root.style.maxHeight = maxHeight + 'px';
                }

                if (this.isOpen) {
                    this.$root.style.bottom = '0px';
                } else {
                    this.$root.style.bottom = '-750px';
                }
            }
        }
    }

    addStartChatHandler() {
        if (this.$chatStartBtn) {
            this.$chatStartBtn.addEventListener('click', e => {
                this.startChat();

                this.$greetingTextBlock.classList.add('-started');
                this.$chatStartBlock.classList.add('-hide');

                setTimeout(() => {
                    this.$chatStartBlock.classList.add('-hidden');
                }, 300);
            }, {
                once: true,
            });
        }

        if (this.$chatStartHolderBtn) {
            this.$chatStartHolderBtn.addEventListener('click', e => {
                this.toggleWidget();

                if (!this.isStarted) {
                    this.startChat();

                    this.$greetingTextBlock.classList.add('-started');
                    this.$chatStartBlock.classList.add('-hide');

                    setTimeout(() => {
                        this.$chatStartBlock.classList.add('-hidden');
                    }, 300);
                }
            })
        }
    }

    addWidgetOpenHandler() {
        let $widgetOpenBtn;

        if (this.pageMode === 'page') {
            $widgetOpenBtn = document.querySelector('#prof-test-page-widget-button');
        } else if (this.pageMode === 'course') {
            $widgetOpenBtn = document.querySelector('#prof-test-course-widget-button');
        }

        if ($widgetOpenBtn) {
            $widgetOpenBtn.addEventListener('click', e => {
                this.toggleWidget();
            });
        }
    }

    addWindowHandler() {
        window.addEventListener('resize', e => {
            this.initMode();
        });
    }

    addToggleBtnHandler() {
        if (this.$chatToogleBtn) {
            this.$chatToogleBtn.addEventListener('click', e => {
                this.toggleWidget();
            });
        }
    }

    toggleWidget() {
         this.isOpen = !this.isOpen;

         if (this.isOpen) {
             scrollLock.disablePageScroll([document.body]);
         } else {
             scrollLock.clearQueueScrollLocks();
             scrollLock.enablePageScroll(document.body);
         }

        this.initMode();
    }

    startChat() {
        this.isStarted = true;
        this.isOpen = true;

        if (this.$chatListForm) {
            this.$chatListBlock.removeChild(this.$chatListForm);
        }

        if (this.$chatPostForm) {
            this.$chatListBlock.removeChild(this.$chatPostForm);
        }

        if (this.$chatResult) {
            this.$chatResultBlock.removeChild(this.$chatResult);
        }

        this.activeIndex = 0;

        this.$chatResultBlock.classList.add('-hide');
        this.$chatListBlock.classList.remove('-hide');

        this.toggleTypingAction();

        this.fetchChatFromServer((chat) => {
            const $typingBlock = this.$chatListBlock.querySelector('#prof-test-chat-typing');

            if ($typingBlock) {
                this.$chatListBlock.removeChild($typingBlock);
            }

            this.$chatListBlock.innerHTML = chat;

            this.$chatListForm = this.$chatListBlock.querySelector('#profTestChatListForm');

            if (this.$chatListForm) {
                const $allQuestions = this.$chatListForm.querySelectorAll('.prof-test-chat_question');

                if ($allQuestions.length) {

                }$allQuestions.forEach(($question) => {
                    $question.classList.add('-hidden');
                });
            }

            this.nextQuestion(this.activeIndex, false);

            const $progressBlock = this.$root.querySelector('#prof-test-chat-header');

            if ($progressBlock) {
                const $progressContent = $progressBlock.querySelector('.prof-test-chat_header-content');
                const $progressContentRow = $progressContent.querySelector('.prof-test-chat_header-progress');

                $progressContentRow.classList.remove('-hide');

                if ($progressContent) {
                    $progressContentRow.style.height = '0px';
                    $progressContentRow.style.opacity = '0';

                    setTimeout(() => {
                        $progressContentRow.style.height = '16px';
                        $progressContentRow.style.opacity = 1;
                    }, 10);

                    setTimeout(() => {
                        $progressContentRow.style.height = 'auto';
                        $progressBlock.classList.add('-shadow');
                    }, 300);
                }
            }

            if (this.$chatListForm) {
                this.$chatListForm.addEventListener('change', e => {
                    this.onListFormChange(e);
                });

                this.$root.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
            }
        })
    }

    fetchChatFromServer(callback) {
        setTimeout( () => {
            Api.get(`${craft.env.apiSiteUrl}/feed/prof/questions?id=${this.chatId}`).then(data => {
                callback(data);
            });
        }, 500);
    }

    onListFormChange(event) {
        const $selectedOption = event.target.closest('#prof-test-chat-question-option');
        const $optionsBlock = event.target.closest('#prof-test-chat-question-options');
        const $optionsContentBlock = event.target.closest('.prof-test-chat_question-content');

        const $allOptionsBlock = $optionsBlock.querySelectorAll('#prof-test-chat-question-option');

        $allOptionsBlock.forEach($option => {
            $option.classList.remove('-selected');
            $option.classList.add('-not-selected');

            const input = $option.querySelector('input[type="radio"]');
            input.disabled = true;
        });

        $selectedOption.classList.remove('-not-selected');
        $selectedOption.classList.add('-selected');
        $optionsContentBlock.classList.add('-selected');

        const next = this.activeIndex + 1;

        const $allQuestion = this.$chatListForm.querySelectorAll('.prof-test-chat_question');

        if (next < $allQuestion.length) {
            this.activeIndex += 1;
            this.nextQuestion(this.activeIndex, true);
        } else {
            this.toggleProgress(this.activeIndex + 1, $allQuestion.length);
            this.checkChatListForm();
        }
    }

    toggleTypingAction() {
        const $cloneTypingBlock = this.$chatTypingTemplate.cloneNode(true);
        const $questionBox = $cloneTypingBlock.querySelector('.prof-test-chat_question');

        this.$chatListBlock.appendChild($cloneTypingBlock);

        const offsetHeight = $questionBox.offsetHeight;

        $questionBox.style.height = '0px';

        setTimeout(() => {
            $questionBox.style.height = offsetHeight + 'px';
            $questionBox.style.opacity = 1;
            }, 10);

        setTimeout(() => {
            $questionBox.style.height = 'auto';

            const scrollTop = this.$root.scrollHeight;
            this.$root.scrollTo({
                top: scrollTop,
                behavior: "smooth",
            });
        }, 300);
    }

    nextQuestion(index, typing) {
        const $allQuestions = this.$chatListForm.querySelectorAll('.prof-test-chat_question');

        if ($allQuestions.length) {
            const $targetQuestion = $allQuestions[index];

            if ($targetQuestion) {
                this.toggleProgress(index, $allQuestions.length);

                if (typing) {
                    this.toggleTypingAction();
                }

                let offsetHeight = 0;

                setTimeout(() => {
                    const $typingBlock = this.$chatListBlock.querySelector('#prof-test-chat-typing');

                    if ($typingBlock) {
                        this.$chatListBlock.removeChild($typingBlock);
                    }

                    $targetQuestion.classList.remove('-hidden');

                    offsetHeight = $targetQuestion.offsetHeight;

                    $targetQuestion.style.height = '46px';
                }, typing ? 500: 0);

                setTimeout(() => {
                    $targetQuestion.style.height = offsetHeight + 'px';
                    $targetQuestion.style.opacity = 1;

                    setTimeout(() => {
                        $targetQuestion.style.height = 'auto';

                        const scrollTop = this.$root.scrollHeight;
                        this.$root.scrollTo({
                            top: scrollTop,
                            behavior: "smooth",
                        });

                        if ($targetQuestion.getAttribute('data-type') === 'motivational') {
                            this.activeIndex += 1;
                            this.nextQuestion(this.activeIndex, true);
                        }
                    }, 300);
                }, typing ? 510: 10);
            }
        }
    }

    checkChatListForm() {
        this.toggleTypingAction();

        if (this.$chatListForm.checkValidity()) {
            setTimeout(() => {
                const $typingBlock = this.$chatListBlock.querySelector('#prof-test-chat-typing');

                if ($typingBlock) {
                    this.$chatListBlock.removeChild($typingBlock);
                }

                const $clonePostForm = this.$chatPostFormTemplate.cloneNode(true);
                const $questionBox = $clonePostForm.querySelector('.prof-test-chat_question');

                this.$chatListBlock.appendChild($clonePostForm);

                this.$chatPostForm = this.$chatListBlock.querySelector('#prof-test-chat-post-form');

                const AllAnswers = this.$chatListForm.querySelectorAll('input[type="radio"]:checked');
                const answers = Array.from(AllAnswers).map(item => {
                    return Number(item.value);
                })

                new ProfTestChatForm(this.chatId, answers, this.afterPostFormSubmit.bind(this));

                const offsetHeight = $questionBox.offsetHeight;

                $questionBox.style.height = '46px';

                setTimeout(() => {
                    $questionBox.style.height = offsetHeight + 'px';
                    $questionBox.style.opacity = 1;
                }, 10);

                setTimeout(() => {
                    $questionBox.style.height = 'auto';

                    const scrollTop = this.$root.scrollHeight;
                    this.$root.scrollTo({
                        top: scrollTop,
                        behavior: "smooth",
                    });
                }, 300);
            }, 500);
        }
    }

    toggleProgress(cur, total) {
        const diff = (cur / total) * 100;

        if (diff < 1) {
            this.$chatProgressTemplate.style.width = '1%';
        } else if (diff > 100) {
            this.$chatProgressTemplate.style.width = '100%';
        } else {
            this.$chatProgressTemplate.style.width = diff + '%';
        }
    }

    afterPostFormSubmit(responce) {
        const $optionsContentBlock = this.$chatPostForm.querySelector('.prof-test-chat_question-content');

        if ($optionsContentBlock) {
            $optionsContentBlock.classList.add('-selected');
        }

        this.toggleTypingAction()

        if (responce && responce.status === "fulfilled") {
            if (responce.value && responce.value.data && responce.value.data.html) {
                setTimeout(() => {
                    const $typingBlock = this.$chatListBlock.querySelector('#prof-test-chat-typing');

                    if ($typingBlock) {
                        this.$chatListBlock.removeChild($typingBlock);
                    }

                    this.$chatResultBlock.classList.remove('-hide');
                    this.$chatResultBlock.innerHTML = responce.value.data.html;
                    this.$chatResult = this.$chatResultBlock.querySelector('#prof-test-chat-post-result-list');

                    this.addRestartChatHandler();

                    const offsetHeight = this.$chatResultBlock.offsetHeight;

                    this.$chatResultBlock.style.height = '46px';

                    setTimeout(() => {
                        this.$chatResultBlock.style.height = offsetHeight + 'px';
                        this.$chatResultBlock.style.opacity = 1;
                    }, 10);

                    setTimeout(() => {
                        this.$chatResultBlock.style.height = 'auto';

                        this.$chatResult.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
                    }, 300);
                }, 500);
            }
        }
    }

    addRestartChatHandler() {
        const $restartBtn = this.$chatResult.querySelector('#prof-test-chat-post-result-reset');

        if ($restartBtn) {
            $restartBtn.addEventListener('click', e => {
                this.startChat();
            }, {
                once: true,
            });
        }
    }
}